import { render, staticRenderFns } from "./PsiFormTrixField.vue?vue&type=template&id=4d51873d&"
import script from "./PsiFormTrixField.vue?vue&type=script&lang=js&"
export * from "./PsiFormTrixField.vue?vue&type=script&lang=js&"
import style0 from "./PsiFormTrixField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d51873d')) {
      api.createRecord('4d51873d', component.options)
    } else {
      api.reload('4d51873d', component.options)
    }
    module.hot.accept("./PsiFormTrixField.vue?vue&type=template&id=4d51873d&", function () {
      api.rerender('4d51873d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lib/PsiFormTrixField.vue"
export default component.exports